
import {
    Box, TextField, FormControl, InputAdornment, InputLabel, Input, IconButton, Button,
    Typography, Select, MenuItem, FormHelperText, Alert, Checkbox, Paper, Divider, Accordion,
	AccordionSummary,
	AccordionDetails,
} from '@mui/material';
import { AccountCircleOutlined, Visibility, VisibilityOff, LockOutlined, Group, ExpandMore as ExpandMoreIcon, } from '@mui/icons-material';
import { useState, useEffect } from 'react';
import { useSelector, useDispatch, } from 'react-redux';
import { range, set, uniqBy } from 'lodash';
import { Tabs } from '../../components/tabs';
import { Grid } from '../../components/table';
import {GroupTemplates} from './groupTemplate';
import { CONFIG } from '../../../config'
import axios from 'axios';

const API_HOST = CONFIG.modules['accounts'].host

export const MyTeams = (props) => {
    const { roles, user, users, Designations, Departments, Languages, Districts, TaskTypes, Campaigns } = useSelector((state) => (state.user || {}))
    const userStore = useSelector((state) => (state.user || {}))
    const [campaign, setCampaign] = useState('')
    const [campaignMap, setCampaignMap] = useState({})
    const dispatch = useDispatch()

    const [tasks, setTasks] = useState([]);
    const [tasksMap, setTasksMap] = useState({});
    const [myTeams, setMyTeams] = useState([]);

    const getMyTeams = () => {
        axios
            .get(API_HOST + `/get-my-teams`)
            .then((resp) => {
                if (resp.data && resp.data.success) {
                    setMyTeams(resp.data?.teams)
                }
            })
            .catch((e) => {
                console.log(e);
            });
    };

    // useEffect(() => {
    //     if (Campaigns) {
    //         setCampaignMap(Campaigns.reduce((a, c) => {
    //             a[c._id] = c
    //             return a;
    //         }, {}))
    //         setCampaign(Campaigns[0]._id)
    //     }
    // }, [Campaigns])

    // useEffect(()=> {
    //     if(campaign) {
           
    //     }
        
    // }, [campaign])

    useEffect(()=>{
        getMyTeams();
    },[])

    // useEffect(()=> {
    //     console.log('user roles', users)
    // },[users])



    return (
        <>
            
            <Box>
                <Box sx={{ display: 'flex', width: '15%', mt: 3 }}>
                   
                </Box>
                <Box>
                    {
                       myTeams.length > 0 && myTeams.map((team) => {
                            return ( <Paper key={team._id}>
                                <div className="container">
                                    <div>
                                        <div className="px-3">
                                            <div className="p-3">
                                                <div className="text-center m-2">
                                                    <div>
                                                        <strong>
                                                            <h4> {team.department.name} </h4>
                                                        </strong>
                                                    </div>
                                                    <div>
                                                        Total -{" "}
                                                        {team.members.length}
                                                    </div>
                                                </div>
                                                {/* <Divider /> */}
                                            </div>
    
                                            <div className="list my-3">
                                            <Accordion>
                                                <AccordionSummary
                                                    expandIcon={<ExpandMoreIcon />}
                                                    aria-controls="panel1a-content"
                                                    id="panel1a-header"
                                                >
                                                    <Typography sx={{fontWeight: 'bold'}}>Members</Typography>
                                                </AccordionSummary>
                                                <AccordionDetails>
                                                <div className="row justify-content-center">
                                                    {team.members.length > 0 &&
                                                        team.members.map((member) => (
                                                            <div className="col-md-2 mb-3 p-2" key={member._id}>
                                                                <Paper>
                                                                    <div className="text-center  py-3">
                                                                        <div className="img">
                                                                            <img
                                                                                src="https://t4.ftcdn.net/jpg/03/32/59/65/240_F_332596535_lAdLhf6KzbW6PWXBWeIFTovTii1drkbT.jpg"
                                                                                alt=""
                                                                                width={100}
                                                                                className="rounded-circle"
                                                                            />
                                                                        </div>
                                                                        <div>{member.name || 'Test User'}</div>
                                                                        <div className="small text-secondary">
                                                                            {member.uuid || 'whdy82378'}
                                                                        </div>
                                                                        <div>Tele Caller</div>
                                                                    </div>
                                                                </Paper>
                                                            </div>
                                                        ))}
                                                </div> 
                                                </AccordionDetails>
                                            </Accordion>
                                                

                                            <Accordion>
                                                <AccordionSummary
                                                    expandIcon={<ExpandMoreIcon />}
                                                    aria-controls="panel1a-content"
                                                    id="panel1a-header"
                                                >
                                                    <Typography sx={{fontWeight: 'bold'}}>Group Templates</Typography>
                                                </AccordionSummary>
                                                <AccordionDetails>
                                                <GroupTemplates team={team}/>
                                                </AccordionDetails>
                                            </Accordion>
                                                
                                                <div className="mt-3">
                                                    <Divider />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Paper>)
                        })
                    }
               
                </Box>
            </Box>

        </>
    )
}